import dayjs from 'dayjs';

export const getLastAction = (actions) => {
  const lastAction = Array.isArray(actions)
    ? actions[actions.length - 1]?.action
    : undefined;

  return lastAction;
};

export const getAppointmentLastAction = (appointment) => {
  const { actions } = appointment;
  return getLastAction(actions);
};

export const isAppointmentCompleted = (appointment) => {
  const lastAction = getAppointmentLastAction(appointment);
  return !!lastAction && lastAction?.value !== 'arrived';
};

export function isTimeGreaterOrEqualThan(time1, time2) {
  if (time1 === time2) return true;

  // Split the time strings into arrays of [hours, minutes, seconds]
  const splitTime1 = time1.split(':').map(Number);
  const splitTime2 = time2.split(':').map(Number);

  // Compare hours
  if (splitTime1[0] > splitTime2[0]) {
    return true;
  } else if (splitTime1[0] < splitTime2[0]) {
    return false;
  }

  // If hours are equal, compare minutes
  if (splitTime1[1] > splitTime2[1]) {
    return true;
  } else if (splitTime1[1] < splitTime2[1]) {
    return false;
  }

  // If minutes are equal, compare seconds
  return splitTime1[2] > splitTime2[2];
}

export const getFormattedDate = (items) => {
  const { filter } = items.date;
  const date = new Date(items.data[0].dateStart);

  if (filter === 'Daily') {
    // If appt is not this year, display year
    const format =
      dayjs(items.date.date).year() !== dayjs().year()
        ? 'dddd MMMM YYYY, DD'
        : 'dddd MMMM, DD';
    return dayjs(items.date.date).format(format);
  }
  if (filter === 'Weekly') {
    const getFirstDay = date.getDate() - date.getDay();
    const firstDay = getFirstDay < 0 ? 1 : getFirstDay;
    const lastDay = firstDay + 6;
    return `${dayjs(items.data[0].dateStart).format('MMMM')}, ${
      firstDay + 1
    } - ${lastDay + 1}`;
  }
  if (filter === 'Monthly') {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const lastDay = new Date(year, month, 0).getDate();
    return `${dayjs(items.date.date).format('MMMM')}, 1 - ${lastDay}`;
  }
};

// Gives us earliest and latest opening business times
export function findOpeningHours(times) {
  if (!times || times.length === 0) {
    return { earliestStart: '00:00:00', latestEnd: '23:45:00' };
  }
  // Initialize with the first element's times to ensure a correct comparison
  let earliestStart = times[0].time.start;
  let latestEnd = times[0].time.end;

  times.forEach((item) => {
    if (item.time.start < earliestStart) {
      earliestStart = item.time.start;
    }
    if (item.time.end > latestEnd) {
      latestEnd = item.time.end;
    }
  });
  return {
    earliestStart: `${earliestStart.split(':')[0]}:00:00`,
    latestEnd: addHourToTimeString(latestEnd),
  };
}

function addHourToTimeString(timeString) {
  // Assuming the date doesn't matter, prepend a dummy date
  const date = new Date(`1970-01-01T${timeString}Z`);

  // Add an hour
  date.setTime(date.getTime() + 3600000);

  const formattedTimeString = date
    .toISOString()
    .split('T')[1]
    .split('Z')[0]
    .replace('.000', '');

  if (formattedTimeString.split(':')[0] === '00') {
    return '23:59:00';
  }
  return formattedTimeString;
}
